import React, { Component } from 'react';
import QR from 'qrcode.react';
import { Button, Input, Icon, message } from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { returnComma } from '../../common/utils';
import { UserAction } from '../../actions';
import { requestChargeCrypto, getUserInfo } from '../../common/fetch';

class Payment extends Component {

	componentDidMount() {
		const { user = {}, currency } = this.props;
		const { charge_wallet = {} } = user;
		if (!charge_wallet[currency]) {
			this.requestCrypto(currency);
		}
	}

	requestCrypto = async (currency) => {
		try {
			const res = await requestChargeCrypto(currency);
			if (res.data) {
				await this.getUserData();
			}
		} catch (err) {
			let error = err && err.data
				? err.data.message
				: err.message;
			if (err && err.data) {
				message.error(error);
			}
		}
	};

	getUserData = async () => {
		const { userAction } = this.props;
		try {
			const res = await getUserInfo();
			userAction.readData(res.data);
		} catch (err) {
			let error = err && err.data
				? err.data.message
				: err.message;
			if (err && err.data) {
				message.error(error);
			}
		}
	};

	componentWillUnmount() {
		clearInterval(this.interval);
	}

	copy = (e) => {
		const copyText = e.input;
		/* Select the text field */
		copyText.select();
		copyText.setSelectionRange(0, 99999); /*For mobile devices*/

		/* Copy the text inside the text field */
		document.execCommand('copy');
		message.success('Copied!');
	};

	render() {
		const { user, currency, amount, next } = this.props;
		const { charge_wallet } = user;
		const chargeAddress = charge_wallet[currency] || '';
		return (
			<div className="payment">
				<div className="payment-info">
					<p>
						<b>Send Exactly:</b>
						&nbsp;{returnComma(amount)} {currency.toUpperCase()}
					</p>
					<div>
						<p>
							<b>Payment Address</b>
						</p>
						<Input
							ref={(el) => {
								this.apiKey = el;
							}}
							value={chargeAddress}
							readOnly
							addonAfter={
								<Icon
									type="copy"
									onClick={() => this.copy(this.apiKey)}
								/>
							}
						/>
					</div>
				</div>
				<div className="currency-info">
					<div className="disclamar">
						Due cryptocurrency price fluctuations the amounts quoted are estimates. 
						After your transaction has been confirmed the exact transaction details will be sent to your email.
					</div>
					{/* <p>
						<b>XHT Market Exchange Rate:</b> $0.25 USDT per XHT
					</p>
					<p>
						<b>You account will be charged approximately:</b>
						470,811.4 XHT (~$94,162.28 USDT)
					</p> */}
				</div>
				<div className="qr-code">
					<QR value={chargeAddress} />
				</div>
				<div className="btn-area">
					<Button block type="primary" onClick={next}>
						Done
					</Button>
				</div>
			</div>
		);
	}
}

const mapDispatchToProps = (dispatch) => ({
	userAction: bindActionCreators(UserAction, dispatch)
});

export default connect(null, mapDispatchToProps)(Payment);
